import notification, { options } from 'toastr';

let cfg = {};

export let cottageDataList = [];
export let cottageData = {
  cottageId: '',
  name: '',
  images: [],
  rate: 0,
  cottageStatus: 0,
  overview: {
    Title: '',
    Description: '',
    Guests: 0,
    Bedrooms: 0,
    Beds: 0,
    Baths: 0,
    SleepingArrangements: '',
    Deposit: 0,
  },
  amenities: {
    ScenicViews: '',
    Bathroom: '',
    BedroomAndLaundry: '',
    Entertainment: '',
    Family: '',
    HeatingAndCooling: '',
    HomeSafety: '',
    InternetAndOffice: '',
    KitchenAndDining: '',
    LocationFeatures: '',
    Outdoor: '',
    ParkingAndFacilities: '',
    Services: '',
  },
  package: {},
  rates: {},
  calendar: {},
  misc: {},
};

export let bookingData = {
  bookingId: '',
  fromDate: '',
  toDate: '',
  cottageId: '',
  email: '',
  phone: '',
  notes1: '',
  notes2: '',
  bookingStatus: 0,
  bookingDetail: {
    Adults: 0,
    Child: 0,
    TotalNights: 0,
    TotalRooms: 0,
    TotalGuests: 0,
  },
  billingDetail: {
    FirstName: '',
    LastName: '',
    Address: '',
    AppartmentSuiteUnit: '',
    City: '',
    Country: '',
    EmailAddress: '',
    Phone: '',
  },
  misc: {
    CottageName: '',
    Guests: '',
    Bedrooms: '',
    Beds: '',
    Baths: '',
    Deposit: '',
  },
  paymentDetails: {
    CottageRate: 0,
    ServiceFee: 0,
    TotalNights: 0,
    Tax: 0,
    Discounts: 0,
    TotalCharges: 0,
    Status: 0,
  },
};

export let settingsAdminData = {
  bookingDefaultStatus: 1,
  minimumBookingDays: 2,
  defaultCheckinDay: 'Saturday',
  weeklyBookingMonthStart: 'July',
  weeklyBookingMonthEnd: 'August',
  weeklyBookingPrice: 1650,
};

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',

  // These options are needed to round to whole numbers if that's what you want.
  minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const renderSpinner = (parent) => {
  const loader = `<div id="spinner" class="spinner-border text-primary ml-2" role="status">
    <span class="sr-only">Loading...</span>
</div>`;

  parent.insertAdjacentHTML('afterend', loader);
  parent.disabled = true;
};

export const renderSpinnerButton = (parent) => {
  parent.innerHTML = '';
  const loader = `<span class="spinner-border spinner-border-sm"></span>
        Processing Payment..`;

  parent.insertAdjacentHTML('beforeend', loader);
  parent.disabled = true;
};
export const clearSpinnerButton = (parent) => {
  parent.innerHTML = 'Pay Now';
  // console.log("clearLoader -> elementStrings.loader", elementStrings.loader)
  parent.disabled = false;
};

export const clearSpinner = () => {
  const loader = document.querySelector(`#spinner`);
  // console.log("clearLoader -> elementStrings.loader", elementStrings.loader)
  console.log('clearLoader -> loader', loader);
  if (loader) {
    loader.parentElement.removeChild(loader);
  }
};

export const createDateFromDateString = (dateString) => {
  var dateParts = dateString.split('-');

  // Create a new Date object with local time set to midnight
  var date = new Date(
    dateParts[0], // Year
    dateParts[1] - 1, // Month (0-indexed)
    dateParts[2] // Day
  );

  // Reset the time to midnight to avoid timezone issues
  date.setHours(0, 0, 0, 0);

  return date;
};

export const notify_Info = (message, title = 'Info') => {
  notification.info(message, title, {
    positionClass: 'toast-bottom-full-width',
  });
};

export const notify_Success = (message, title = 'Success') => {
  notification.success(message, title, {
    positionClass: 'toast-bottom-full-width',
  });
};

export const notify_Warning = (message, title = 'Warning') => {
  notification.warning(message, title, {
    positionClass: 'toast-bottom-full-width',
  });
};

export const notify_Error = (message, title = 'Error') => {
  notification.error(message, title, {
    positionClass: 'toast-bottom-full-width',
  });
};

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const generateConfirmationNumber = () => {
  const date = new Date();
  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const today = `${year}${month}${day}`;

  let confirmationNumber = '';
  for (let i = 0; i < 6; i++) {
    confirmationNumber += Math.floor(Math.random() * 10);
  }

  const uniqueConfirmationNumber = `${today}-${confirmationNumber}`;
  return uniqueConfirmationNumber;
};

export const jsonToHtmlTable = (json) => {
  let html = '<table>';
  html += '<tr>';
  for (const key in json[0]) {
    html += `<th>${key}</th>`;
  }
  html += '</tr>';
  for (const object of json) {
    html += '<tr>';
    for (const key in object) {
      html += `<td>${object[key]}</td>`;
    }
    html += '</tr>';
  }
  html += '</table>';
  return html;
};

export const pipestringToList = (inputString) => {
  return inputString.split('|');
};

export const multiSelectValuetoPipeString = (input) => {
  const selectedOptions = input;
  const selectedValues = Array.from(selectedOptions).map(
    (option) => option.value
  );
  const selectedValuesString = selectedValues.join('| ');
  return selectedValuesString;
};
